import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TransitionContainer from '../../components/Transition/TranstionContainer';
import ConfirmationCard from '../../components/Shared/ConfirmationCard';

import { setExitingCardProps, getExitingCardProps } from '../Widget/actions';

import { ActionTypes } from '../../utils/enums';
import { formatThousands } from '../../utils/fillDynamicText';
import { copyFor } from '../../copy/copy';

import CopyLink from '../../components/RecordVideo/VideoLinkContainer';

const RecordVideoConfirmation = props => (
    <TransitionContainer
        zIndex={9}
        isSubmitting={props.isSubmitting}
        isBackTransition={props.isBackTransition}
    >        
        <ConfirmationCard
            rightAlign
            thankYouText={props.thankYouText}
            thankYouTitle={props.thankYouTitle}
            peopleCount={props.peopleCount}
            useLocalRepresentative={props.useLocalRepresentative}
            forceLargeTitle={true}

            linkComponent={
                <CopyLink
                    videoURL={props.videoURL}
                    fullVideoURL={props.fullVideoURL}
                    downloadIsReady={true}
                    style={{marginTop: '16px'}}
                />
            }

            altShareDefaultTwitterFacebookMessage={
                props.altShareDefaultTwitterFacebookMessage
            }
            altShareCustomFacebookMessage={
                props.altShareCustomFacebookMessage
            }
            altShareCustomTwitterMessage={
                props.altShareCustomTwitterMessage
            }
            altSharingButtonsAreShort={true}
            altSharingURL={props.videoURL}

            beforeAdvancing={() => {
                props.setExitingCardProps('recordvideo', props, props.exitingAction);
            }}
            noCountdown={true}
            {...props}
        />
    </TransitionContainer>
);

RecordVideoConfirmation.propTypes = {
    altShareDefaultTwitterFacebookMessage: PropTypes.string,
    altShareCustomFacebookMessage: PropTypes.string,
    altShareCustomTwitterMessage: PropTypes.string,
    enableAltEndCardSharing: PropTypes.bool,
    exitingAction: PropTypes.object.isRequired,
    isPortrait: PropTypes.bool,
    partnerName: PropTypes.string,
    peopleCount: PropTypes.string.isRequired,
    repFullName: PropTypes.string,
    setExitingCardProps: PropTypes.func.isRequired,
    thankYouText: PropTypes.string.isRequired,
    thankYouTitle: PropTypes.string,
    useLocalRepresentative: PropTypes.bool,
    fullVideoURL: PropTypes.string,
    thumbnailURL: PropTypes.string,
    videoURL: PropTypes.string,
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'recordvideo',
            ['/recordvideo/emailsuccess'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        const fullVideoURL = state.recordVideo.fullVideoURL;
        const thumbnailURL = state.recordVideo.thumbnailURL;
        const videoURL = state.recordVideo.videoURL;

        const altShareDefaultTwitterFacebookMessage = 
            copyFor('thankYou', 'altShareMessage', 'recordvideo')
                .replace(/@userVideoUrl/g, videoURL);

        const altShareCustomFacebookMessage =
            state.widget.activeAction.altSharingFacebookMessage &&
            state.widget.activeAction.altSharingFacebookMessage
                .replace(/@userVideoUrl/g, videoURL);

        const altShareCustomTwitterMessage =
            state.widget.activeAction.altSharingTwitterMessage && 
            state.widget.activeAction.altSharingTwitterMessage
                .replace(/@userVideoUrl/g, videoURL);

        return {
            altShareDefaultTwitterFacebookMessage,
            altShareCustomFacebookMessage,
            altShareCustomTwitterMessage,
            enableAltEndCardSharing: state.widget.activeAction.enableAltEndCardSharing,
            exitingAction: state.widget.activeAction,
            isPortrait: state.widget.isMobileResolution,
            partnerName: state.widget.activeAction.partner
                ? state.widget.activeAction.partner.name
                : 'Speakable',
            peopleCount:
                state.petition.completePetition !== undefined
                    ? formatThousands(state.petition.completePetition.endUsersCount)
                    : '',
            repFullName: state.localRep.localRepData.representative
                ? state.localRep.localRepData.representative[0].fullName
                : '',
            thankYouText: state.widget.activeAction.thankYouText || copyFor('thankYou', 'description', 'recordvideo'),
            thankYouTitle: state.widget.activeAction.thankYouTitle || copyFor('thankYou', 'title', 'recordvideo'),
            useLocalRepresentative: !!state.widget.activeAction.representativeSearch,
            videoURL,
            thumbnailURL,
            fullVideoURL,

        };
    },
    { setExitingCardProps },
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.Petition) return true;
            return next === prev;
        }
    }
)(RecordVideoConfirmation);
